<template>
    <vx-modal v-model:visible="visible" size="md" padding="standard">

        <template v-slot:header>
            Two-Factor Authentication
        </template>

        <vx-alert color="success" :closeable="false">
            In order to use two-factor authentication, you must install the Google Authenticator or any other compatible application on your smartphone.
        </vx-alert>
        <template v-if="qrImage">
            <div class="d-flex justify-content-center">
                <div data-test="svg-qr-code" v-html="qrImage"></div>
            </div>
        </template>

        <vx-alert color="info" :closeable="false">
            If you lose your two-factor authentication device, you may use this emergency reset token to disable two-factor authentication on your account.
            <strong>This is the only time this token will be displayed, so be sure not to lose it!</strong>
        </vx-alert>

        <vx-popover hover arrow placement="top">
            <div
                @click.prevent="copyToken()"
                data-test="copy-token"
                class="vx-font-mono vx-break-all vx-cursor-pointer vx-p-4 vx-bg-white vx-rounded-sm vx-mt-4"
            >
                {{ props.twoFactorResetCode }} <font-awesome-icon :icon="faCopy"></font-awesome-icon>
            </div>
            <template v-slot:content> Click to Copy </template>
        </vx-popover>

        <template v-slot:footer>
            <div class="vx-flex vx-flex-col-reverse vx-gap-4 lg:vx-flex-row">
                <vx-button
                    @click.prevent="visible = false"
                    tabindex="1"
                    type="button"
                    class="vx-grow lg:vx-w-20 lg:vx-grow-0"
                    size="lg"
                    color="muted"
                >
                    Close
                </vx-button>
                <vx-button @click.prevent="copyToken()" type="button" size="lg" block color="primary">
                    Copy Reset Token <font-awesome-icon :icon="faCopy"></font-awesome-icon>
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script setup>
import { faCopy } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxAlert, VxButton, VxModal, VxPopover } from '@voxie/frontend-components';
import { useCopyText } from '~/composables/useCopyText';

const visible = defineModel('visible', {
    type: Boolean,
    default: false,
});

const props = defineProps({
    twoFactorResetCode: {
        type: String,
        default: null
    },
    qrImage: {
        type: String,
        default: null
    }
});

const { copyText } = useCopyText();

const copyToken = () => {
    copyText(props.twoFactorResetCode);
};
</script>
